// flow weak

import React , { PureComponent }                             from 'react';
  import PropTypes              from 'prop-types';
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';
  import styles                 from './style'
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog'
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  // import CsvDownloader from 'react-csv-downloader';
  
  import {
    AnimatedView,
    StatsTable,ScoreCard,StatsGraph,LocationMenu
  }                         from '../../../components';
  import {Link} from 'react-router-dom';
  import ReactTooltip from 'react-tooltip'
  import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol,
  SmallTableHeader,
}                         from '../../../components';
import ReactTable from "react-table";
import { isNull } from 'util';
import reactDOM from "react-dom";
import {Row,Col} from "react-bootstrap";
import { Multiselect } from 'react-widgets'
import CircularProgress from 'material-ui/CircularProgress';
import locationMenu from '../../../redux/modules/locationMenu.js'
import 'react-widgets/dist/css/react-widgets.css';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import CustomerDetails from '../crud/customerDetails';
import Avatar from 'material-ui/Avatar';
import ScheduleDemo from '../crud/scheduleDemo';
import EditLead from '../crud/editLead';
import AddSubscription from '../crud/addSubscription';
import AddLead from '../crud/addLead';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';


// import CancelScheduledDemo from '../crud/cancelScheduledDemo'

const customStyles = {
  content : {
    top                   : '13%',
    left                  : '1%',
    right                 : '1%',
    bottom                : '1%',  
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '15'
   }
};

const customStyles1 = {
  content : {
    top                   : '5%',
    left                  : '5%',
    right                 : '5%',
    bottom                : '5%',  
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '10000'
   }
};
class DemoScheduledLeads extends PureComponent {
    static propTypes = {
      earningGraphLabels:   PropTypes.array,
      revenueChart:  PropTypes.shape({
        headers: PropTypes.array,


        data: PropTypes.array
      }),
      earningGraphDatasets: PropTypes.array,
      teamMatesIsFetching:  PropTypes.bool,
      teamMates:            PropTypes.arrayOf(
        PropTypes.shape({
          picture:      PropTypes.string,
          firstname:    PropTypes.string,
          lastname:     PropTypes.string,
          profile:      PropTypes.string,
          profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
        })
      ),
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        open:false,
        page: 1,
        pages: 10,
        pageSize: 100,
        rowCount:0,
        inputValue:"",
        sortOption: [],
        buddies: [],
        lead_list: [],
        lead_headings: [],
        selectedLocation: props.props.scoreCard,
        isFetching: props.props.scoreCard.sales_score_card.isFetching,
        selected_name : '',
        temp_list:[],
        temp_list_game:[],
        temp_list_status:[],
        temp_list_quality:[],
        temp_list_source:[],
        venue_list: [],
        quality_list:[],
        game_list: [],
        all_games: [],
        status_list:[],
        location_list:[],
        location_data:[],
        city:'',
        locations:[],
        selected_venue: [],
        selected_game: [],
        selected_status: [],
        selected_quality:[],
        selected_source:[],
        selected_date: moment(),
        search:false,
        location:props.props.scoreCard.sales_score_card.requested_venue_id,
        sortColumn:['status','follow_up_date'],
        sortOrder:false,
        selected_customer_id:'',
        popUpVisible:false,
        expected_payment:false,
        date: moment().format('DD/MM/YYYY'),
        temp_lead_programs:[],
        expanded: {},
        lead_details: {
          customer_id:'',
          name:'',
          email:'',
          status:'',
          comment:'',
          quality:'',
          follow_up_date:'',
          buddy_id:''
        },
        selected_lead_programs:[],
        selected_lead_locations:[],
        selected_lead_games: [],
        selected_programs :[],
        temp_lead_programs:[],
        temp_lead_locations:[],
        temp_selected_programs:[],
        name:'',
        isExpended: false,
        customer_leads:[],
        source_list:[{'source':'bbfs customer','name':'source'},{'source':'Customer App Sign Up','name':'source'},{'source':'Facebook','name':'source'},{'source':'FB','name':'source'},{'source':'myoperator','name':'source'},{'source':'playo','name':'source'},{'source':'Sporthood Badminton - RM Nagar','name':'source'},{'source':'Sporthood Kormangala','name':'source'},{'source':'Website','name':'source'},{'source':'other','name':'source'}]
        };
      this.findHotLeads = this.findHotLeads.bind(this);
      this.onSelect = this.onSelect.bind(this);
      this.handleShowDetails = this.handleShowDetails.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onLeadChange = this.onLeadChange.bind(this);
      this.onLeadSelect = this.onLeadSelect.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.closeModal = this.closeModal.bind(this);
      this.onClicked = this.onClicked.bind(this);
      this.postSaveChanges = this.postSaveChanges.bind(this);
      this.handleStartDate = this.handleStartDate.bind(this);
      this.saveChanges = this.saveChanges.bind(this);
      this.onProgramSelect = this.onProgramSelect.bind(this);
      this.onProgramChange = this.onProgramChange.bind(this);
      this.handleCityChange = this.handleCityChange.bind(this);
    }

  

    closeModal() {
      this.setState({popUpVisible: false});
      this.handleShowDetails();
    }

    handleStartDate(date){
      var new_selected_one =  Object.assign({}, this.state.lead_details);
      new_selected_one['follow_up_date'] = date
      this.setState({lead_details: new_selected_one});
    }

    componentDidMount() {
      this.getVenueList();
      this.getGameList();
      this.buddyList();
      this.getQualityList();
      this.findHotLeads(this.state.location);
      this.getAllLocations();
      this.getGames()
      if(this.state.open){
        document.body.style.overflow = 'hidden';
      }  
    }
    componentWillUnmount() {
      document.body.style.overflow = 'unset';
    }
 
    handleShowDetails(){
      this.findHotLeads(this.state.location)   
    }

    buddyList(){
    const url = `${getLocationOrigin()}/cm/list_all_buddies/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ buddies: data.data}))
       .catch(error => error);

  }

    onClicked(e,id){
      this.setState({name:e, popUpVisible:true,selected_customer_id:id});
    }

    openModal(e){
      this.setState({name:e, popUpVisible:true});
    }

    handleChange(event){
      var new_value =  Object.assign({}, this.state.lead_details);
      var value = event.target.value
      var name = event.target.name
      console.log('handleChange..')
      console.log(value)
      console.log(name)
      new_value[name] = value
      this.setState({lead_details:new_value})
    }

    handleCityChange(event){
      var value = event.target.value
      var new_loc = this.state.location_data.find(data=> data.city_id == value).locations
      this.setState({city:value,locations:new_loc})
    }

    missedCallsms(props,id) {
      const url = `${getLocationOrigin()}/lead/lead_missed_call_sms/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({'customer_id': id});
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(function(response){
            alert(response.message);
        })
        .catch(error => {
          console.log(error);
          console.log(error.message);
        });
    }

    venueSms(props,id) {
      const url = `${getLocationOrigin()}/lead/send_venue_sms/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({'customer_id': id});
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(function(response){
            alert(response.message);
        })
        .catch(error => {
          console.log(error);
          console.log(error.message);
        });
    }

    passToWhatsapp(props,mobile_no) {
      location.href = `whatsapp://send?phone=91${mobile_no}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`
    }

    openWhatsapp(mobile_no) {
      window.open(`https://web.whatsapp.com/send?phone=91${mobile_no}&lang=en&text=Hi%0A%3CCM%20name%3E%20from%20Sporthood%20here`,
        '_blank')
    }


    findHotLeads(location){ 
      this.setState({is_fetching: true})
      var temp = this.state.sortOrder
      var url = `${getLocationOrigin()}/sales/find_leads/?page=${this.state.page}&source=CM&sortColumn=${this.state.sortColumn}&sortOrder=${this.state.sortOrder}&type=demo_leads`;
      this.setState({loading:true})


      if(this.state.selected_venue.length > 0 ){
        var venue_list = []
        url = url + "&venue_id=" 
        for(var i in this.state.selected_venue)
        {
          venue_list.push(this.state.selected_venue[i])
        }
        url = url + venue_list
      }


      if(this.state.selected_source.length > 0 ){
        var source_list = []
        url = url + "&lead_source=" 
        for(var i in this.state.selected_source)
        {
          source_list.push(this.state.selected_source[i])
        }
        url = url + source_list
      }


      if(this.state.selectedLocation.sales_score_card.isFetching){
        url = url +"&location="+location


        

        if(this.state.selected_status.length > 0 ){
          var status_list = []
          url = url + "&status="
          for(var j in this.state.selected_status)
          {
            status_list.push(this.state.selected_status[j])
          }
          url = url + status_list
        }


        if(this.state.selected_game.length >0){
          var game_list = []
          url = url + "&game="
          for(var k in this.state.selected_game){
            game_list.push(this.state.selected_game[k])  
          }
          url = url + game_list
        }


        if(this.state.selected_quality.length >0){
          var quality_list = []
          url = url + "&quality="
          for(var l in this.state.selected_quality){
            quality_list.push(this.state.selected_quality[l])  
          }
          url = url + quality_list
        }


        this.state.selectedLocation.sales_score_card.isFetching = false
      }
      else{
        url = url +"&location="+location
        if(this.state.selected_status.length > 0 ){
          var status_list = []
          url = url + "&status="
          for(var j in this.state.selected_status)
          {
            status_list.push(this.state.selected_status[j])
          }
          url = url + status_list
        }
        

        if(this.state.selected_game.length >0){
          var game_list = []
          url = url + "&game="
          for(var k in this.state.selected_game){
            game_list.push(this.state.selected_game[k])  
          }
          url = url + game_list
        }


        if(this.state.selected_quality.length >0){
          var quality_list = []
          url = url + "&quality="
          for(var l in this.state.selected_quality){
            quality_list.push(this.state.selected_quality[l])  
          }
          url = url + quality_list
        }
        

      }
      

       const options = {...defaultOptions};
      
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
        if(data.results.length > 0){
          this.setState({
            sortOrder: temp,
            is_fetching: false, 
            lead_list: data.results,
            pageSize:data.page_size,
            rowCount:data.results_count,
            pages:data.num_pages ,
            lead_headings: Object.keys(data.results[0]), 
            loading:false,
            expanded:{}
          })
        }
        else{
          this.setState({is_fetching: false, lead_list: data.results, loading:false,expected_payment:data.tag,expanded:{}})
        }
        })
         .catch(error => error);
    }


    // getLocationList(locations,id){
    //   var loc = []
    //   locations.forEach(data=> loc.push(data))
    //   const url = `${getLocationOrigin()}/get_venue_list/get_hoods/?location=${loc}`;
    //    const options = {...defaultOptions};
  
    //   return fetch(url, options)
    //      .then(checkStatus)
    //      .then(parseJSON)
    //      .then(data => this.setState({location_list: data.result},()=>{this.customerLeads(id)}))
    //      .catch(error => error);
    // }

    getAllLocations(){
       const url = `${getLocationOrigin()}/get_venue_list/get_hoods/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({location_data:data.result,city: data.result[0].city_id,locations:data.result[0].locations}))
         .catch(error => error);
    }


    getQualityList(){
      const url = `${getLocationOrigin()}/court/get_quality/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({quality_list: data.quality}))
         .catch(error => error);
    }


    getVenueList(){
      const url = `${getLocationOrigin()}/court/get_venues/?type=demos`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => 
          this.setState({venue_list: data.results, status_list:data.status}))
         .catch(error => error);
    }

    getGameList(){
       const url = `${getLocationOrigin()}/court/get_games/`;
        const options = {...defaultOptions};
  
       return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => this.setState({game_list:data.results}))
          .catch(error => error);
     } 

    getGames(){
       const url = `${getLocationOrigin()}/court/get_games_list/`;
        const options = {...defaultOptions};
  
       return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => this.setState({all_games:data.result}))
          .catch(error => error);
     } 

   connectCall(call) {
    const url = `${getLocationOrigin()}/calls/connect_customer/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                                        'customer_no': call.mobile_no_hidden,
                                        'source':'CM'
                                          });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                     
          alert(response.message);
          // props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
   }  

   customerLeads(id){
    var selected_id = this.state.id;
    if(id){
      selected_id = id
    }
    const url = `${getLocationOrigin()}/customer_list/get_customer_leads/?customer_id=${selected_id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
        var leads_data = data.customer_leads.leads
        if(data.customer_leads.leads.length > 3){
          leads_data = data.customer_leads.leads.slice(0,3)
        }
        this.setState({customer_leads:leads_data})
      })
       .catch(error => error);
    }

    saveChanges(props,data,locations,games,programs){
      var date = moment(data.follow_up_date).format("YYYY-MM-DD");
      const url = `${getLocationOrigin()}/lead/save_lead_changes/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                        'customer_id': data.customer_id,
                                        'name': data.name,
                                        'comment': data.comment,
                                        'quality': data.quality,
                                        'status': data.status,
                                        'email': data.email,
                                        'follow_up_date': date,
                                        'selected_games': games,
                                        'selected_locations': locations,
                                        'selected_programs':programs,
                                        'buddy_id':data.buddy_id

                                      });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(response => {                     
            alert(response.message);
            if(response.success){
              this.setState({},()=>{this.handleShowDetails()})
            }
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

    postSaveChanges(props){
      var selected_games = []
      var selected_locations = []
      var selected_programs = this.state.selected_programs
      this.state.selected_lead_games.forEach(data=>{
        selected_games.push(data.pk)
      })
      this.state.selected_lead_locations.forEach(data=>{
        selected_locations.push(data.id)
      })

      if(this.state.lead_details.comment.length == 0){
        alert('Please provide comment for changes')
      }
      else if(selected_programs.length == 0 && selected_games.length > 0){
        alert('Please select at least one program')
      }
      else if(selected_programs.length > 0 && selected_games.length == 0){
        alert('Please select at least one game for selected program')
      }
      else{
        this.saveChanges(props,this.state.lead_details,selected_locations,selected_games,selected_programs)
      }
    }


    onSelect(optionsList, selectedItem) {
     
      var name = optionsList.name ;
      if(name=== 'venue'){
        this.state.temp_list.push(optionsList.id)
        this.setState({ selected_venue: this.state.temp_list,selected_name: name });
      }
      else if(name === 'game'){
        this.state.temp_list_game.push(optionsList.pk)
        this.setState({ selected_game:this.state.temp_list_game , selected_name: name});
      }
      else if(name === 'status'){
        this.state.temp_list_status.push(optionsList.id)
        this.setState({selected_status: this.state.temp_list_status, selected_name: name});
      }
      else if(name === 'quality'){
        this.state.temp_list_quality.push(optionsList.id)
        this.setState({selected_quality: this.state.temp_list_quality, selected_name: name});
      }
      else if(name == 'source'){
        this.state.temp_list_source.push(optionsList.source)
        this.setState({selected_source: this.state.temp_list_source, selected_name: name});

      }
    }

    onChange(dataItem,event){
      var name = event.dataItem.name
        
      if(name === 'venue'){
        this.setState({page:1, selected_venue:dataItem.map(x => x.id),selected_name: name }, () => this.findHotLeads(this.state.location) );
      }
      else if(name === 'game'){
        this.setState({page:1, selected_game:dataItem.map(x => x.pk), selected_name: name}, () => this.findHotLeads(this.state.location) );
      }
      else if(name === 'status' ){
        this.setState({page:1, selected_status: dataItem.map(x => x.id), selected_name: name}, () => this.findHotLeads(this.state.location)  );
      }
      else if(name === 'quality' ){
        this.setState({page:1, selected_quality: dataItem.map(x => x.id), selected_name: name}, () => this.findHotLeads(this.state.location)  );
      } 
      else if(name === 'source'){
        this.setState({page:1, selected_source: dataItem.map(x => x.source), selected_name: name}, () => this.findHotLeads(this.state.location)  );
      }   
     
    }

    onLeadSelect(optionsList,selectedItem) {
      var name = optionsList.name ;
      if(name=== 'game'){
        this.state.temp_lead_programs.push(optionsList)
        this.setState({ selected_lead_games: this.state.temp_lead_programs});
      }
      if(name=== 'location'){
        this.state.temp_lead_locations.push(optionsList)
        this.setState({ selected_lead_locations: this.state.temp_lead_locations});
      }
    }

    onLeadChange(dataItem,event){
      var name = event.dataItem.name
      if(name === 'game'){
        this.setState({page:1, selected_lead_games:dataItem.map(x => x)});
      }
      if(name === 'location'){
        this.setState({page:1, selected_lead_locations:dataItem.map(x => x)});
      }
    }

    onProgramSelect(optionsList,selectedItem){
      var program = this.state.selected_programs;
      program.push(selectedItem)
      this.setState({selected_programs:program})
    }

    onProgramChange(dataItem,event){
      this.setState({selected_programs:dataItem.map(x => x)})
    }

    callBack(id) {
      var call = this.state.lead_list.find(temp => temp.customer_id_hidden == id)
      this.connectCall(call)
    }
  
    render() {      
      console.log('calling render*******')
      var loc = this.state.selectedLocation.sales_score_card.isFetching

      if(loc){
        var location = this.state.selectedLocation.sales_score_card.requested_venue_id
        this.findHotLeads(location)
        this.setState({isFetching:false,location:location})
      }


      $(".venue .searchBox").click(function(){

          $('.venue .optionListContainer').show();

      });

      var programs = ['Adults Playing','Adults Training','Kids Coaching','Court Rental']

      var headings_list =  this.state.lead_headings.slice()
      
      
      
      headings_list.push("Actions");
      headings_list.push("Message")
     var csvData = [];
      var rows = this.state.lead_list.map(function(lead,index){
        var row = { ...lead }
        var headers = ["Customer","Program","Status","Mobile_no","Follow_up_date","Quality","Comment","Source"];
        var csvHeader = ["customer","program","status","mobile_no","follow_up_date","quality","comment","source"];

        csvData[0] = headers;
        

        var j;
        var csv = []
        for(j=0;j<csvHeader.length;j++){
          if(csvHeader[j] == 'status'){
            var s = '' 
            {row[csvHeader[j]]==10 ? s = 'Response' : row[csvHeader[j]]==20 ? s = "Contact Later" : row[csvHeader[j]]==30 ? s = "Demo Scheduled" : row[csvHeader[j]]==40 ? s = "Did Not Demo" : row[csvHeader[j]]==50 ? s = "Verbal Confirmation" : row[csvHeader[j]]==70 ? s = "Paid" : row[csvHeader[j]]==80 ? s = "Dead Lead" : row[csvHeader[j]]==85 ? s = "Dropped" : row[csvHeader[j]]==90 ? s = "Dormant" : row[csvHeader[j]]==100 ? s = "Injured Customer" : row[csvHeader[j]]==120 ? s = "Demo Attended" :row[csvHeader[j]]==130 ? s = "Temporarily Inactive" : row[csvHeader[j]]==60 ? s = "Did Not Signup"  : s = "None"}
            csv.push(s);
          }
          else if(csvHeader[j] == 'mobile_no'){
            var s = row.mobile_no_hidden
            csv.push(s);
          }
          else{
            csv.push(row[csvHeader[j]]);
          }
        }
        csvData.push(csv);

        if(row.customer == ''){
          if((row.status == 110 || row.status == 50) && (row.follow_up_date >= moment().format('DD/MM/YYYY'))){
            row["customer"] = '<a target="_blank"'+'href="https://cm.sporthood.in/#/crud/customerDetails/'+row.customer_id_hidden+'">'+'__payment'+'</a>';
          }
          else{
            row["customer"] = '<a target="_blank"'+'href="https://cm.sporthood.in/#/crud/customerDetails/'+row.customer_id_hidden+'">'+'__'+'</a>';
          }
        }
        else{
          if((row.status == 110 || row.status == 50) && (row.follow_up_date >= moment().format('DD/MM/YYYY'))){
            row["customer"] = '<i class="fa fa-usd fa-x" style="color: green;">'+' '+'</i>'+'<a target="_blank"'+'href="https://cm.sporthood.in/#/crud/customerDetails/'+row.customer_id_hidden+'">'+row.customer+'</a>';
          }
          else{
            row["customer"] = '<a target="_blank"'+'href="https://cm.sporthood.in/#/crud/customerDetails/'+row.customer_id_hidden+'">'+row.customer+'</a>';            
          }
        }


        
        
        if(row.status == 10){
          row["status"] = '<p style = "color: black; background-color:#DF744A;" >' + "Response" + '</p>';
        }
        else if(row.status == 20){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Contact Later" + '</p>';
        }
        else if(row.status == 85){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Dropped" + '</p>';
        }
        else if(row.status == 90){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Dormant" + '</p>';
        }
        else if(row.status == 110){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Payment Due" + '</p>';
        }
        else if(row.status == 30){
          row["status"] = '<p style = "color: black; background-color:#F79E45;" >' + "Demo Scheduled" + '</p>';
        }
        else if(row.status == 40){
          row["status"] = '<p style = "color: black; background-color:#F79E45;" >' + "Did Not Demo" + '</p>';
        }
        else if(row.status == 50){
          row["status"] = '<p style = "color: black; background-color:#04BFB9;" >' + "Verbal Confirmation" + '</p>';
        }
        else if(row.status == 120){
          row["status"] = '<p style = "color: black; background-color:#F79E45;" >' + "Demo Attended" + '</p>';
        }
        else if(row.status == 130){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Temporarily Inactive" + '</p>';
        }
        else if(row.status == 100){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Injured Customer" + '</p>';
        }
        else if(row.status == 70 ){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Negative Feedback" + '</p>';
        }
        else if(row.status == 80 ){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Dead Lead" + '</p>';
        }
        else if(row.status == 60 ){
          row["status"] = '<p style = "color: black; background-color:#BBF467;" >' + "Did Not Signup" + '</p>';
        }


        

        row["mobile_no"] = '<button style = "color: black; background-color:#EEA083;</style>" >' + row.mobile_no + '</button>';

        row["Actions"] = '<span class=badge badge-default style=cursor:pointer;background-color:#32CD32;color:white><i class="fa fa-phone fa-2x"></i></span>'; 
        row["Message"] = '<span><i style="cursor:pointer;font-size:2.1vw; color: rgb(37, 211, 102); margin-right: 0.5vw;" class="fa fa-whatsapp" aria-hidden="true"></i></span>'

        if(row.quality == 'Sure Payment'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i></span>';
        }
        if(row.quality == 'Highly Likely'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i></span>';
        }
        if(row.quality == 'May Pay'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i></span>';
        }
         if(row.quality == 'No Response'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i><i class="fa fa-star" style="color: orange;"></i></span>';
        }
         if(row.quality == 'Will Not Pay'){
          row["quality"] = '<span><i class="fa fa-star" style="color: orange;"></i></span>';
        }

        


        
        return row
 

      });
      
    const headings = headings_list.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = element;//For react-table
      heading["displayName"] = element.charAt(0).toUpperCase() + element.slice(1);
      heading["Header"] = element.charAt(0).toUpperCase() + element.slice(1); //For react-table
      if(element == 'program' || element == 'mobile_no' || element == 'View' || element == 'Actions'){
        heading["sortable"] = false;
      }
      else{
        heading["sortable"] = true;
      }
      if(element == 'Actions'){
        heading["minWidth"] = 50;
      }else if(element == 'comment' || element == 'program'){
        heading["minWidth"] = 100;
      }else if(element == 'mobile_no'){
        heading["minWidth"] = 70;
      }else{
        heading["minWidth"] = 60;
      }
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });   
       
     this.state.lead_headings.map(function(key,index){
     });      
      
      
      const {
        statsTable, scoreCard,statsGraph
      } = this.props;

      var csvHeader = ["customer","program","status","mobile_no","follow_up_date","quality","comment","source"];
       csvData[0] =  ['']
       console.log('csvdata')
       console.log(csvData)


    return( 

        <div className="col-md-12 table-bordered" style={styles.table} style={{marginLeft: '8px'}}>
          
          <div style={{width:'100%',marginBottom:'2%'}}>
            <div style={styles.items} className=" col-md-2 col2" style={{marginTop: '8px',width:'19%'}}>
                  {this.state.status_list.length>0 && 
              <Multiselect
                placeholder="Status"
                data={this.state.status_list}
                textField='status'
                onSelect={this.onSelect}
                onChange={this.onChange} 
                filter='contains'

               />
              } 
            </div>

            <div style={styles.items} className="col-md-2 col2" style={{flexDirection:'column',marginTop: '8px',width:'19%'}}>
                  {this.state.game_list.length>0 && 
              <Multiselect
                id="3"  
                placeholder="Program"
                data={this.state.game_list}
                textField='game'
                onSelect={this.onSelect} 
                onChange={this.onChange}
                filter='contains' 
               />
              } 
            </div>      


            <div style={styles.items} className="col-md-2 col2" style={{flexDirection: 'column', marginTop: '8px',width:'19%'}}>
               {this.state.venue_list.length>0 && 
              <Multiselect
                id="1"
                placeholder="Venue"
                data={this.state.venue_list}
                textField='value'
                onSelect={this.onSelect} 
                onChange={this.onChange} 
                filter='contains'
               />
              } 
            </div>

            <div style={styles.items} className="col-md-2 col2" style={{flexDirection: 'column', marginTop: '8px',width:'19%'}}>
               {this.state.quality_list.length>0 && 
              <Multiselect
                placeholder="Quality"
                data={this.state.quality_list}
                textField='quality'
                onSelect={this.onSelect} 
                onChange={this.onChange} 
               />
              } 
            </div>

            <div style={styles.items} className="col-md-3 col2" style={{flexDirection:'column',marginTop: '8px',width:'19%'}}>
                  {this.state.source_list.length>0 && 
              <Multiselect
                id="3"  
                placeholder="Source"
                data={this.state.source_list}
                textField='source'
                onSelect={this.onSelect} 
                onChange={this.onChange}
                filter='contains' 
               />
              } 
            </div>
            <i className="fa fa-refresh fa-2x" aria-hidden="true" onClick={this.handleShowDetails} style={{marginLeft:'1%',marginTop: '8px',color:'#04BFB9',cursor:'pointer'}}></i>

            
          

          <div style={{float:'right'}}>
            <ReactHTMLTableToExcel
                        id="btn btn-lg"
                        className="download-table-xls-button"
                        table="table-to"
                        filename="Demos - Leads"
                        sheet="Demos - Leads"
                        buttonText="Download "/>
            {/*<CSVLink data={csvData} ><i className="fa fa-floppy-o fa-3x" aria-hidden="true" style={{color:'#04BFB9',marginTop: '5px'}}></i></CSVLink>*/}

            <button className="btn" onClick={() => this.openModal('add_lead_modal')} style={{border: 'none', backgroundColor: '#ece15a', margin: '5px',width:'fit-content',padding:'5px',cursor:'pointer'}}>
              <i className="fa fa-plus-circle" style={{fontSize: 'medium', color: '#000'}}></i>Add Lead
            </button>
            <button className="btn"  onClick={() => this.openModal('add_subs_modal')} style={{border: 'none', backgroundColor: '#ece15a', margin: '5px',width:'fit-content',padding:'5px',cursor:'pointer'}}>
             Add Subscription
            </button>

          </div>

          </div>

          {this.state.loading === true ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}><CircularProgress /></div>
              </div>
               
          :

            <div style={{margin:10,marginTop:'7%'}}> 

              <div className="row new-table" >    
                <div className="row col-md-12" style={styles.table} style={{marginLeft: '3px'}}>
                  <ReactTable
                    data={rows}
                    rowsText={this.state.rowCount.toString()}  //Workaround to store the total rows.
                    columns={headings}
                    showPagination={true}
                    showPaginationTop={true}
                    defaultPageSize={100}
                    minRows={0}
                    style={{backgroundColor:'#9370DB',marginRight: '6px'}}
                    filterable={false}
                    orderBy={true}
                    useExpanded
                    defaultFilterMethod= {(filter, row, column) => {
                      const id = filter.pivotId || filter.id
                      return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                    }}
                    manual  
                    pages = {this.state.pages}  
                    page = {this.state.page-1}
                    pageSizeOptions = {[100]}
                    showPageSizeOptions = {false}
                    manualPagination={true}
                    expanded ={this.state.expanded}
                    sorted={this.state.sortOption}
                    onPageChange={page => {
                       this.setState({page: page+1}, () => this.findHotLeads(this.state.location) )
                    }}

                    onExpandedChange={(newExpanded, index, event) => {

                      const row = rows[index]
                      console.log('checking details',row)
                      const games = row.games_hidden
                      const locations = row.location_hidden
                      const lead_programs = row.program_hidden
                      var new_value =  Object.assign({}, this.state.lead_details);
                      var filtered_games = this.state.all_games.filter(game=> games.includes(game.pk))
                      var filtered_locations = []
                      if(row.city_hidden){
                        filtered_locations = this.state.location_data.find(data=> data.city_id == row.city_hidden).locations
                      }
                      var selected_loc = []
                      if(filtered_locations){
                        selected_loc = filtered_locations.filter(data => locations.includes(data.id))
                      }
                      new_value['customer_id'] = row.customer_id_hidden
                      new_value['name'] = row.customer_name_hidden
                      new_value['email'] = row.email_hidden
                      new_value['quality'] = row.quality_hidden
                      new_value['status'] = row.status_hidden
                      new_value['follow_up_date'] = row.follow_up_date
                      new_value['buddy_id'] = row.buddy_hidden[0]
                      if (newExpanded[index[0]] === false) {
                          newExpanded = {}
                      } else {
                          Object.keys(newExpanded).map(k => {
                              newExpanded[k] = parseInt(k) === index[0] ? {} : false
                          })
                      }

                      this.setState({ expanded: newExpanded,selected_programs:lead_programs,selected_lead_games:filtered_games,
                      selected_lead_locations:selected_loc,lead_details:new_value,isExpended:true,
                      city:row.city_hidden,locations:filtered_locations})
                    }} 
                  

                    onSortedChange = { sortOption => {
                       this.setState({sortOption:sortOption,  sortColumn: sortOption[0].id,sortOrder:sortOption[0].desc}, () => this.findHotLeads(this.state.location) )
                       

                    }}                 

                    getTrProps={(state, rowinfo, column) => {
                      var bgcolor = '#dcdcdc';
                      if (rowinfo!=undefined && rowinfo.row.hasOwnProperty("style_hidden")) {
                          var row_style = rowinfo.row["style_hidden"]
                          if(row_style!=null && row_style.indexOf('row-danger') != -1){
                            bgcolor = '#FFC8B8';
                          }else if(row_style!=null && row_style.indexOf('row-warning') != -1){
                            bgcolor = '#FFE699';
                          }
                      }              
                      return {
                        style: {
                          background: 'white',height:'50px'
                        }
                        
                        
                      };
                    }}

                    getTdProps={(state, rowInfo, column, instance) => {

                      return {

                        
                          onClick: (e, handleOriginal) => {
                              if(column.displayName === 'Mobile_no'){
                                this.setState({selected_customer_id:rowInfo.row.customer_id_hidden,popUpVisible:true,mobile_popup:true} )
                              }

                              if(column.displayName === 'Actions'){
                                this.setState({selected_customer_id:rowInfo.row.customer_id_hidden})
                                this.callBack(rowInfo.row.customer_id_hidden)
                              }

                              if(column.displayName === 'Message'){
                                this.openWhatsapp(rowInfo.row.mobile_no_hidden)
                              }

                              // IMPORTANT! React-Table uses onClick internally to trigger
                              // events like expanding SubComponents and pivots.
                              // By default a custom 'onClick' handler will override this functionality.
                              // If you want to fire the original onClick handler, call the
                              // 'handleOriginal' function.
                              if (handleOriginal) {
                                handleOriginal()
                            }
                          }

                      }
                    }}  

                    SubComponent={row => {
                      console.log('checking SubComponent',row)
                      return (
                        <div style={{backgroundColor:'#ddd',color:'black'}}>
                          <div style={{ padding: "5px",flexDirection: 'row', display: 'flex', justifyContent: 'space-between',fontWeight: 600}}>
                            {row.original.app_version_hidden ? 'App Version - '+row.original.app_version_hidden : 'App Not Downloaded'}
                          </div>
                          <div style={{ padding: "15px",flexDirection: 'row', display: 'flex',width:'100%'}}> 
                            <div style={{flexDirection: 'column', display: 'flex'}} className='col-md-8'>
                            <div style={{flexDirection: 'row', display: 'flex',width:'100%'}}>
                              <div style={{width:'15%'}}>
                                <Avatar size={90}  src={row.original.photo_hidden.includes('http')? row.original.photo_hidden : 'https://api.sporthood.in'+row.original.photo_hidden} />
                              </div>  
                              <div style={{flexDirection: 'column',display: 'flex'}} className='col-md-6'>

                                <div style={styles.items}>
                                  <div style={row.original.customer_name_hidden ? {fontWeight:600,paddingLeft: '2%'}:{color:'red',fontWeight:600,paddingLeft: '2%'}} className='col-md-4'>
                                    Name 
                                  </div>
                                  <input style={styles.item_body} name="name" value={this.state.lead_details.name ? this.state.lead_details.name : row.original.customer_name_hidden}
                                  onChange={this.handleChange} />
                                </div>
                                <div style={styles.items}>
                                  <div style={styles.item_header} className='col-md-4'>
                                    Number 
                                  </div>
                                  {row.original.mobile_no_hidden}
                                </div>
                                <div style={styles.items}>
                                  <div style={row.original.email_hidden ? {fontWeight:600,paddingLeft: '2%'}:{color:'red',fontWeight:600,paddingLeft: '2%'}} className='col-md-4' >
                                    Email 
                                  </div>
                                  <input style={styles.item_body} name="email" value={this.state.lead_details.email ? this.state.lead_details.email : row.original.email_hidden}
                                  onChange={this.handleChange} />
                                </div>
                                <div style={styles.items}>
                                  <div style={styles.item_header} className='col-md-4'>
                                    Type 
                                  </div>
                                  <div className='col-md-6'>
                                    {row.original.customer_type_hidden}
                                  </div>
                                </div>
                              </div>

                              <div style={{flexDirection: 'column',display: 'flex'}} className='col-md-6'>
                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className='col-md-4'>
                                    Status 
                                  </div>
                                  <select name="status" className="col-md-8" style={styles.item_body} value={this.state.lead_details.status ? this.state.lead_details.status : row.original.status_hidden}
                                   onChange={this.handleChange}>
                                    { 
                                       this.state.status_list.map((status,index)=>(
                                         <option key={status.id} value={status.id}>{status.status}</option>
                                        ))
                                    }
                                  </select>
                                </div>
                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className='col-md-4'>
                                    Quality 
                                  </div>
                                  <select name="quality" className="col-md-8" style={styles.item_body} value={this.state.lead_details.quality ? this.state.lead_details.quality : row.original.quality_hidden}
                                   onChange={this.handleChange}>
                                    { 
                                       this.state.quality_list.map((data,index)=>(
                                         <option key={data.id} value={data.id}>{data.quality}</option>
                                        ))
                                    }
                                  </select>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className='col-md-6'>
                                    Follow Up Date 
                                  </div>
                                  <div className='col-md-6'>
                                  <DatePicker selected={moment(this.state.lead_details.follow_up_date)} onChange={this.handleStartDate}/>
                                  </div>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className='col-md-6'>
                                    Last Updated By 
                                  </div>
                                  {/*<div className='col-md-6'>
                                    {row.original.buddy_hidden.length > 0 ? row.original.buddy_hidden[0] : ''}
                                  </div>*/}
                                  <select name="buddy_id" className="col-md-6" style={styles.item_body} value={this.state.lead_details.buddy_id}
                                    onChange={this.handleChange}>
                                    <option>------</option>
                                    { this.state.buddies ? 
                                      this.state.buddies.map((x, index) => (
                                      <option key={x.id} value={x.id}>{x.buddy}</option>
                                      ))
                                      :
                                      <option>Loading...</option>
                                    }
                                  </select>
                                </div>
                             
                              </div>
                              </div>

                              <div style={{ padding: "15px",color:'white',flexDirection: 'row', display: 'flex',justifyContent:'space-between'}}>

                            <div style={styles.items} style={{flexDirection:'column',marginTop: '0.8vw'}}>
                              {this.state.all_games.length>0 && 
                                <Multiselect
                                  placeholder="Game Interested"
                                  data={this.state.all_games}
                                  textField='game'
                                  onSelect={this.onLeadSelect} 
                                  onChange={this.onLeadChange}
                                  filter='contains' 
                                  value = {this.state.selected_lead_games}
                                 />
                                } 
                            </div> 
                            <div style={styles.items} style={{flexDirection:'column',marginTop: '0.8vw'}}>
                              {programs.length>0 && 
                                <Multiselect
                                  placeholder="Program Interested"
                                  data={programs}
                                  onSelect={this.onProgramSelect} 
                                  onChange={this.onProgramChange}
                                  filter='contains'
                                  value = {this.state.selected_programs} 
                                 />
                                } 
                            </div> 
                            <div style={styles.items} style={{flexDirection:'column',marginTop: '0.8vw'}}>
                              <select name="city" style={styles.item_body} value={this.state.city}
                               onChange={this.handleCityChange}>
                                  <option>------</option>
                                { 
                                   this.state.location_data.map((data,index)=>(
                                     <option key={data.city_id} value={data.city_id}>{data.city_name}</option>
                                    ))
                                }
                              </select>
                            </div>
                            <div style={styles.items} style={{flexDirection:'column',marginTop: '0.8vw'}}>
                              {this.state.locations.length>0 && 
                                <Multiselect
                                  placeholder="Location Interested"
                                  data={this.state.locations}
                                  textField='location'
                                  onSelect={this.onLeadSelect} 
                                  onChange={this.onLeadChange}
                                  filter='contains' 
                                  value = {this.state.selected_lead_locations}
                                 />
                                } 
                            </div>
                            
                          </div>

                          <div style={{ padding: "15px",flexDirection: 'column', display: 'flex',justifyContent:'space-around'}}>
                              <div style={{display:'flex',flexDirection:'column'}}>
                                <div style={{fontWeight:'600'}} >
                                  Last Comments 
                                </div>
                                <div  style={{display:'flex',flexDirection:'column'}}>
                                  {this.state.customer_leads.length > 0 ?
                                    this.state.customer_leads.map((lead,idx)=>
                                    <div>
                                      <div className='col-md-12' style={{flexDirection: 'row', display: 'flex',justifyContent:'space-around'}}>
                                        <div className='col-md-2'>{lead.created_on}</div>
                                        <div className='col-md-2'>{lead.buddy[0]}</div>
                                        <div className='col-md-8'>{lead.comment}</div>
                                      </div>
                                    </div>
                                      

                                    )
                                    :
                                    ''
                                  }
                                </div>
                              </div>
                              <div style={{display:'flex',flexDirection:'column'}}>
                                <div style={{width:'10%',fontWeight:'600'}} >
                                  Comment 
                                </div>
                                <textarea style={styles.item_body} name="comment" placeholder={row.original.comment}
                                  onChange={this.handleChange} Row='3' col='3' />
                              </div>
                            </div>
                          </div>


                            <div style={{flexDirection: 'column',display: 'flex',width:'18%'}} className='col-md-2'>
                              <div className="col-md-1" style={{marginBottom: '1%'}}>
                                <button onClick={(e) => this.onClicked('EditLead',row.original.customer_id_hidden)}
                                  style={{
                                      backgroundColor: '#FDD60B',
                                      color: '#000',
                                      marginBottom: '2%',
                                      width:'12vw',borderColor: '#FDD60B', borderWidth: '1px',paddingTop:'0.4vw',paddingBottom:'0.4vw'
                                  }}>

                                  <span style={{color: '#000'}}></span>
                                  Edit Lead
                                </button>
                              </div>

                              <div className="col-md-1" style={{marginBottom: '1%'}}>
                                <button onClick={(e) => this.onClicked('ScheduleDemo',row.original.customer_id_hidden)}
                                  style={{
                                      backgroundColor: '#FDD60B',
                                      color: '#000',
                                      marginBottom: '1%',
                                      width:'12vw',borderColor: '#FDD60B', borderWidth: '1px',paddingTop:'0.4vw',paddingBottom:'0.4vw'
                                  }}>

                                  Schedule Demo
                                </button>
                              </div>

                              <div className="col-md-1" style={{marginBottom: '1%'}}>
                               <button  style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '1px',width:'12vw',alignSelf:'center',alignItems:'center',alignText:'center',marginBottom: '1%',paddingTop:'0.4vw',paddingBottom:'0.4vw'}}
                                type="button" onClick={()=>this.venueSms(this.props,row.original.customer_id_hidden)}>Venue SMS</button>
                              </div>
                              <div className="col-md-1" style={{marginBottom: '1%'}}>
                               <button style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '1px',width:'12vw',paddingTop:'0.4vw',paddingBottom:'0.4vw'}}
                                type="button" onClick={()=>this.missedCallsms(this.props,row.original.customer_id_hidden)}>Missed Call SMS</button>
                              </div>
                            </div>

                            <div style={{flexDirection: 'column',display: 'flex',width:'16%',float:'right'}} className='col-md-2'>
                              <a
                                  href={`https://web.whatsapp.com/send?phone=91${row.original.mobile_no_hidden}&lang=en&text=Hi%0A%3CCM%20name%3E%20from%20Sporthood%20here`}
                                  target="_blank"
                                  className="col-md-12"
                                  style={{
                                      border: '1px solid rgb(37, 211, 102)',
                                      color: 'black',
                                      marginBottom: '0.1vw',
                                      fontSize:'100%',
                                      width:'13vw',
                                      padding:'2%'
                                  }}>
                                  
                                  <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                  Intro Message                                 
                              </a>
                              <a
                                  href={`https://web.whatsapp.com/send?phone=91${row.original.mobile_no_hidden}&lang=en&text=&text=We%20run%20a%20network%20of%20neighbourhood%20sports%20clubs%20across%20Bangalore%20%26%20Kochi.%20You%20can%20book%20courts%2C%20join%20for%20training%20sessions%2C%20skill%20matched%20games%2C%20enroll%20your%20kids%20for%20coaching%2C%20all%20from%20our%20mobile%20app.%20www.sporthood.in%2Fapp`}
                                  target="_blank"
                                  className="col-md-12"
                                  style={{
                                      border: '1px solid rgb(37, 211, 102)',
                                      color: 'black',
                                      marginBottom: '0.1vw',
                                      fontSize:'100%',
                                      width:'13vw',
                                      padding:'2%'
                                  }}>
                                  
                                  <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                  About Us Message                               
                              </a>
                              <a
                                href={`https://web.whatsapp.com/send?phone=91${row.original.mobile_no_hidden}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`}
                                target="_blank"
                                className="col-md-12"
                                style={{
                                    border: '1px solid rgb(37, 211, 102)',
                                    color: 'black',
                                    marginBottom: '0.1vw',
                                    fontSize:'100%',
                                    width:'13vw',
                                    padding:'2%'
                                }}>

                                <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                Football Welcome
                              </a>
                               <a
                                  href={`https://web.whatsapp.com/send?phone=91${row.original.mobile_no_hidden}&lang=en&text=Greetings%20from%20*Sporthood*%21%C2%A0Thanks%20for%20showing%20interest%20in%20playing%20badminton%20with%20Sporthood.%C2%A0%0A%0A*Benefits%20of%20playing%20with%20Sporthood*%0A-%20Skill%20matched%20games%20held%20on%20daily%20basis%0A-%20Certified%20trainers%20help%20improve%20your%20game%20%26%20fitness%0A-%20Leaderboard%20%26%20progress%20monitoring%0A-%20Hoods%20located%20across%20the%20city%0A%0AVisit%20our%20website%20http%3A%2F%2Fbit.ly%2F2DhKeup%20to%20join%20a%20game%20now%21%0A%0AOr%20I%20can%20help%20schedule%20a%20*ONE%20TIME%20FREE%20DEMO*%20for%20the%20same%20on%20your%20confirmation.`}
                                  target="_blank"
                                  className="col-md-12"
                                  style={{
                                      border: '1px solid rgb(37, 211, 102)',
                                      color: 'black',
                                      marginBottom: '0.1vw',
                                      fontSize:'100%',
                                      width:'13vw',
                                      padding:'2%'
                                  }}>
                                  
                                  <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                  Badminton Welcome                                
                              </a> 
                              <a
                                  href={`https://web.whatsapp.com/send?phone=91${row.original.mobile_no_hidden}&lang=en&text=We%20provide%20best%20in%20class%20grass%20roots%20coaching%20for%20kids%2C%20in%20partnership%20with%20the%20best%20in%20the%20business.%20`}
                                  target="_blank"
                                  className="col-md-12"
                                  style={{
                                      border: '1px solid rgb(37, 211, 102)',
                                      color: 'black',
                                      marginBottom: '0.1vw',
                                      fontSize:'100%',
                                      width:'13vw',
                                      padding:'2%'
                                  }}>
                                  
                                  <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                  Academy Intro                                  
                              </a> 

                              <a
                                  href={`https://web.whatsapp.com/send?phone=91${row.original.mobile_no_hidden}&lang=en&text=We%20have%20sports%20based%20fitness%20programs%20for%20adults%20that%20help%20you%20stay%20fit%20and%20active%20while%20playing%20your%20favourite%20sport.%20Our%20expert%20trainers%20will%20work%20on%20both%20your%20skill%20and%20fitness%20to%20make%20sure%20you%20have%20a%20great%20experience.%20`}
                                  target="_blank"
                                  className="col-md-12"
                                  style={{
                                      border: '1px solid rgb(37, 211, 102)',
                                      color: 'black',
                                      marginBottom: '0.1vw',
                                      fontSize:'100%',
                                      width:'13vw',
                                      padding:'2%'
                                  }}>
                                  
                                  <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                  Training Intro                               
                              </a> 

                              <a
                                  href={`https://web.whatsapp.com/send?phone=91${row.original.mobile_no_hidden}&lang=en&text=We%20have%20playing%20memberships%20that%20help%20you%20play%20multiple%20sports%20across%20our%20network%20at%20pocket%20friendly%20rates.%20`}
                                  target="_blank"
                                  className="col-md-12"
                                  style={{
                                      border: '1px solid rgb(37, 211, 102)',
                                      color: 'black',
                                      marginBottom: '0.1vw',
                                      fontSize:'100%',
                                      width:'13vw',
                                      padding:'2%'
                                  }}>
                                  
                                  <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                  Playing Intro                              
                              </a> 

                                                          

                              {/*<a style={{whiteSpace: 'nowrap',color:'yellow'}}
                                                              href={`whatsapp://send?phone=91${row.original.mobile_no_hidden}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation. `}>
                                                              Whatsapp Desktop App
                                                            </a>*/}

                              <div className="col-md-1" style={{marginTop: '7%',padding:'0%'}}>
                               <button style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', borderWidth: '1px',width:'14vw',paddingTop:'0.4vw',paddingBottom:'0.4vw'}}
                                type="button" onClick={()=>this.passToWhatsapp(this.props,row.original.mobile_no_hidden)}>Whatsapp Desktop App</button>
                              </div>

                            </div>
                          </div>
                          <div style={{marginTop: '0.8vw',display:'flex',justifyContent:'flex-end'}} >
                              <button style={{backgroundColor: '#27c24c', borderWidth: '1px',paddingTop:'0.6vw',paddingBottom:'0.6vw',marginRight:'3.6vw',marginBottom:'0.6vw'}}
                                type="button" onClick={()=>this.postSaveChanges(this.props)}><span style={{color: '#000'}}>Save Changes</span></button>
                            </div>
                        </div>
                      );
                    }}                  

                    >



                  {
                    //To show the record count on top  
                    (state, makeTable, instance) => {

                      let recordsInfoText = "";

                      const { filtered, pageRows, pageSize, sortedData, page } = state;

                      if (sortedData && sortedData.length > 0) {
                        let isFiltered = filtered.length > 0;

                        let totalRecords = state.rowsText;

                        let recordsCountFrom = page * pageSize + 1;

                        let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                        if (isFiltered){
                          recordsInfoText = `${totalRecords} filtered records`;
                        }
                        else {
                          recordsInfoText = `${totalRecords} records`;
                        }
                      } else {
                          recordsInfoText = "No records";
                        }
                      return (
                        <div className="main-grid">
                          <div className="above-table text-right">
                            <div className="col-sm-12 records-info">
                              <span className="">{recordsInfoText}</span>
                            </div>
                          </div>
                          {makeTable()}
                          
                        </div>

                      );
                    }
                  }
            </ReactTable>
                </div>
              </div>
            </div>
          }


          <table id="table-to" style={{fontSize:'0%',opacity:'0'}}>
              <tr> 
                {csvHeader.map((head)=>
                  <th>{head}</th>)}
              </tr>
                {csvData.map((data)=>
                  <tr>
                    { data.map((each)=>
                      <td >{each}</td>
                      )
                    }
                  </tr>
                  )}
                
            </table>

          { this.state.popUpVisible ?
            <div >
             <Modal 
                isOpen={this.state.popUpVisible}
                onRequestClose={this.closeModal}
                style={customStyles}

              >
                <button className ="btn" onClick={this.closeModal} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
                
                {(this.state.name== 'EditLead')?
                    <EditLead match={{"params":{"id":this.state.selected_customer_id,"page": this.state.page}}}/>
                  : 
                  ((this.state.name == 'ScheduleDemo')?
                  <ScheduleDemo match={{"params":{"id":this.state.selected_customer_id,"page": this.state.page}}}/>
                  :
                  ((this.state.name == 'add_subs_modal')?
                    <AddSubscription />
                  :
                  ((this.state.name == 'add_lead_modal')?
                    <AddLead />
                  :
                  <CustomerDetails match={{"params":{"id":this.state.selected_customer_id, "page": this.state.page}}}/>
                  )))
                  
                }
                
              </Modal>
            </div>
            :
            ""
            
          }


        </div>       
      );
    }
  }
  
  export default DemoScheduledLeads;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/demoScheduledLeads/DemoScheduledLeads.js